import { internalApi } from "@circle-react/helpers/urlHelpers";
import flatten from "lodash/flatten";
import { useMemo } from "react";
import { keepPreviousData, useInfiniteQuery } from "react-query";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

export const SORT_OPTIONS_MAP = {
  ALPHABETICAL: "alphabetical",
  OLDEST: "oldest",
  LATEST: "latest",
  ROLE: "role",
};

const DEFAULT_PAGE_SIZE = 30;

/**
 * @deprecated Prefer useCommunityMembersInfiniteQueryV2 for new use cases.
 */
export const useCommunityMembersInfiniteQuery = (args = {}) => {
  const {
    query = "",
    sort = SORT_OPTIONS_MAP.ALPHABETICAL,
    order,
    filters = {},
    perPage = DEFAULT_PAGE_SIZE,
    initialPage = 1,
    options = {},
  } = args;

  const fetchPage = ({ pageParam = initialPage }) => {
    let page = 1;

    if (typeof pageParam === "number" && pageParam > 0) {
      page = pageParam;
    }

    const params = {
      page,
      sort,
      filters,
      per_page: perPage,
    };

    if (query) {
      params.query = query;
    }

    if (order) {
      params.order = order;
    }

    return reactQueryGet(internalApi.search.communityMembers.index({ params }));
  };

  const queryKey = ["community-members", query, sort, order, filters, perPage];

  const queryOptions = {
    initialPageParam: initialPage,
    getNextPageParam: lastPage =>
      lastPage.has_next_page ? lastPage.page + 1 : undefined,
    getPreviousPageParam: firstPage =>
      firstPage.page > 1 ? firstPage.page - 1 : undefined,
    placeholderData: keepPreviousData,
    ...options,
  };

  const result = useInfiniteQuery({
    queryKey,
    queryFn: fetchPage,
    ...queryOptions,
  });
  const pages = useMemo(() => result.data?.pages || [], [result.data?.pages]);
  const totalMembers = pages[0]?.meta?.total_count || 0;
  const totalQueryMembers = pages[0]?.count || 0;
  const members = useMemo(
    () => flatten(pages.map(page => page.records)),
    [pages],
  );

  return {
    data: result.data,
    isLoading: result.isInitialLoading,
    isFetching: result.isFetching,
    isFetchingNextPage: result.isFetchingNextPage,
    isFetchingPreviousPage: result.isFetchingPreviousPage,
    hasNextPage: result.hasNextPage,
    hasPreviousPage: result.hasPreviousPage,
    fetchNextPage: result.fetchNextPage,
    fetchPreviousPage: result.fetchPreviousPage,
    refetch: result.refetch,
    isError: result.isError,
    isFetched: result.isFetched,
    queryKey,
    totalMembers,
    totalQueryMembers,
    members,
    pages,
  };
};
